// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchInputStyles } from "@awc/Overrides/Widgets/Header/HeaderSearchInput";
import { color } from "@awc/XDL/Utilities";
import { css } from "styled-components";

searchInputStyles.searchWrapper = {
    css: css`
        ${({ iconMode, isOpen }: any) =>
            iconMode &&
            css`
                position: absolute;
                display: flex;
                column-gap: 12px;
                background-color: ${color("common.ui2")};
                top: -64px;
                left: 0;
                box-shadow: none;
                padding: 12px 16px;
                width: 100%;
                z-index: 1;
                > span {
                    flex: 1;
                }
                transition: top 250ms ease-in-out;
                ${!isOpen
                    ? css`
                          top: -64px;
                      `
                    : css`
                          top: 0;
                      `}
            `}
    `,
};
